// The catalog: task types, the forms and status actions the workflow pages share.
import type { TemplateStatus } from "../../../catalog/types";

export default {
  form: {
    name: "Name",
    slug: "Slug",
    description: "Description",
    icon: "Icon",
    noIcon: "None",
    notSaved: "Not saved",
    slugProblem: "1–32 lowercase letters, digits or hyphens.",
  },
  status: {
    actions: {
      active: "Activate",
      disabled: "Disable",
      archived: "Archive",
      draft: "Back to draft",
    } satisfies Record<TemplateStatus, string>,
    publishFirst: "Publish a version first",
  },
  workflowForm: {
    label: "Workflow details",
    slugHint: "Unique across workflows.",
    taskType: "Task type",
    disabledType: (name: string) => `${name} (disabled)`,
    descriptionPlaceholder: "What it does, shown in the marketplace",
  },
  taskTypes: {
    title: "Task types",
    new: "New task type",
    edit: (name: string) => `Edit ${name}`,
    form: "Task type",
    slugHint: "Unique; how the API and the app refer to it.",
    sortOrder: "Sort order",
    enabled: "Enabled",
    disabled: "Disabled",
    enabledHint: "A disabled type and its workflows are hidden from users.",
    create: "Create task type",
    search: "Search task types",
    searchPlaceholder: "Search by name, slug or description",
    loadError: "Could not load the task types",
    nothingMatches: "Nothing matches",
    noMatch: (q: string) => `No task type matches “${q}”.`,
    empty: "No task types",
    emptyHelp: "Add the kinds of work your users run: Backend, Frontend, Content…",
    columns: { name: "Task type", description: "Description", order: "Order", enabled: "Users see it" },
    saved: (name: string) => `Saved ${name}`,
    created: (name: string) => `Created ${name}`,
    deleted: (name: string) => `Deleted ${name}`,
    deleteTitle: (name: string) => `Delete ${name}?`,
    deleteName: (name: string) => `Delete ${name}`,
    deleteHelp: "Only a task type no workflow belongs to can be deleted; otherwise disable it, which hides it and its workflows from users.",
  },
};
